import _createClass from "/home/runner/work/landing/landing/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/home/runner/work/landing/landing/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _inherits from "/home/runner/work/landing/landing/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/home/runner/work/landing/landing/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/home/runner/work/landing/landing/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Texture } from './Texture.js';

var CompressedTexture = /*#__PURE__*/function (_Texture) {
  _inherits(CompressedTexture, _Texture);

  var _super = _createSuper(CompressedTexture);

  function CompressedTexture(mipmaps, width, height, format, type, mapping, wrapS, wrapT, magFilter, minFilter, anisotropy, encoding) {
    var _this;

    _classCallCheck(this, CompressedTexture);

    _this = _super.call(this, null, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, encoding);
    _this.image = {
      width: width,
      height: height
    };
    _this.mipmaps = mipmaps; // no flipping for cube textures
    // (also flipping doesn't work for compressed textures )

    _this.flipY = false; // can't generate mipmaps for compressed textures
    // mips must be embedded in DDS files

    _this.generateMipmaps = false;
    return _this;
  }

  return _createClass(CompressedTexture);
}(Texture);

CompressedTexture.prototype.isCompressedTexture = true;
export { CompressedTexture };